import EmptyResults from 'components/EmptyResults'
import GridSpinner from 'components/UI/GridSpinner'
import ShowMoreButton from 'components/ShowMoreButton'
import { Button, Icon, List } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useTableConfig } from 'modules/AccountsMarketplace/Products/subcomponents/Table/hooks/useTableConfig'
import { Link } from 'react-router-dom'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { ROUTES } from 'constants/routes'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'

const Table = ({
  data = [],
  pagination,
  loading,
  onChangePage = () => {},
  setSorting = () => {},
  categoryId = null,
}) => {
  const { t } = useTranslation()
  const pathGen = useGeneratePathI18n()
  const breakpoint = useBreakpoint()
  const { tableState, tableConfig } = useTableConfig({ categoryId, setSorting }, data)

  return data.length === 0 && loading ? (
    <GridSpinner />
  ) : (
    <>
      <List
        table={tableState}
        config={tableConfig}
        EmptyComponent={() => (
          <EmptyResults
            header={t('accounts_marketplace::category.empty_list.heading')}
            text={t('accounts_marketplace::category.empty_list.text')}
            icon={<Icon name={'user-add'} />}
            actionButton={
              <Button
                variant={'primary'}
                size={'l'}
                component={Link}
                fullWidth={!breakpoint.fb}
                to={pathGen(ROUTES.ACCOUNTS_MARKETPLACE_CATEGORY_PRODUCTS, {
                  categoryId,
                })}
                startIcon={<Icon name={'plus'} />}
              >
                {t('accounts_marketplace::category.add_product')}
              </Button>
            }
          />
        )}
      />
      <ShowMoreButton
        onClick={() => onChangePage(1)}
        loading={loading}
        current={data.length}
        total={pagination.total}
      />
    </>
  )
}

Table.propTypes = {
  data: PropTypes.array,
  pagination: PropTypes.object,
  loading: PropTypes.bool,
  onChangePage: PropTypes.func,
  i18n: PropTypes.string,
  setSorting: PropTypes.func,
  categoryId: PropTypes.number,
}

export default Table
